export default {
    public: {
        add: 'Add',
        confirm: 'confirm',
        cancel: 'cancel',
        continue: 'continue',
        success: 'success',
        delSuccess: 'Delete successfu',
        copySuccess: 'Copy success',
        downloadFileReady: 'Download file ready',
        downloadFileReadyText: 'Preparation work will be done in the background, you can choose to perform other operations or go to the download center later to view',
        downloadCenter: 'Download center',
        view: 'View',
        fileReadyComplete: 'Download file ready',
        today: 'Today',
        recentThreeDays: 'Recent three days',
        recentOneWeek: 'Recent one week',
        recentOneMonth: 'Recent one month',
        recentThreeMonths: 'Recent three months',
        pleaseEnterKeywords: 'Please enter your keywords',
        all: 'All',
        more:'More',
        edit:'Edit',
        delete: 'Delete',
        doNotSubmitAgain: 'Do not submit again!',
        store: 'Store',
        customPleaseEnterComplete: 'Custom channel please enter complete information！！！',
        pleaseSelectData: 'Please select data',
        platform: 'platform',
        name: 'name',
        price: 'price',
        craft: 'craft',
        size: 'size',
        status: 'status',
        save: 'save',
        color: 'color',
        noData: 'noData',
        remark: 'remark',
        systemOperationDocument: 'systemOperationDocument',
        startTime: 'Start time',
        endTime: 'End time',
        createStartTime: 'Create start time',
        createEndTime: 'Create end time',
        to: 'To',
        operation: 'Operation',
        category: 'Category',
        upload: 'Upload',
        createTime: 'Create time',
        reset: 'Reset',
        operationTime: 'Operation time',
        order: 'Order',
        no:'No',
        yes:'Yes',
        themeName: 'Theme name',
        readThemeName: 'Read the subject name of the corresponding language of the product, and if the product has a store alias, the store alias will be read.',
        blankProductName: 'Blank product name',
        readBlankProductName: 'Read the blank product name in the language corresponding to the store。',
        description: 'Blank product description',
        readDescription: 'Read the product description filled in the current product template.',
        tags: 'Product tags',
        readTags: "Read all product tags, using the variable '{'tags'}'; \n" +
            "Read the first few product tags and add a suffix, using the variable '{'tag + number + suffix '}', such as '{'tag5 t shirt'}'; \n" +
            "Read a few random product tags with a suffix using the variable '{'rtag+number + suffix '}', e.g. '{'rtag5 case'}'",
        sizeName: 'Size name',
        readSizeName: 'Read the custom size name set in the current product template, if not set, the default size name will be read.',
        brandName: 'Brand',
        readBrandName: 'Read the brand name filled in the current product template.',
        pending: 'Pending',
        designing: 'Designing',
        designComplete: 'Design complete',
        inProduction: 'In production',
        qualityInspection: 'Quality inspection',
        delivery: 'Delivery',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
        processing: 'Processing',
        processingText: 'System is processing, please wait...',
        maxNumData: 'You can only operate up to {maxNum} data at a time',
    },

    home: {
        onlineDesign: 'Online design',
        submitOnline: 'Submit online',
        regionLanguage: 'Region language',
        home: 'Home',
        allSelect: 'All select',
        workbench: 'Workbench',
        searchForProducts: 'Search for products',
        goLogin: 'Go login',
        customOrder: 'Custom order',
        generateOrder: 'Generate order',
        deliveryOrder: 'Delivery order',
        productCustomizable: 'Products can be customized',
        cumulativeFreeElements: 'Accumulate free elements',
        startSelecting: 'Start selecting',
        efficientSelecting: 'Efficient product selection',
        efficientSelectingText: 'The platform offers a wide range of customized products for distributors to choose from',
        designShelf: 'Design hit the shelves',
        designShelfText: 'High-quality materials, efficient design of high-quality products',
        efficientProduction: 'efficientProduction',
        efficientProductionText: 'Orders are synchronized, and the order is distributed to the factory for production',
        oneClickDelivery: 'oneClickDelivery',
        oneClickDeliveryText: 'It is very convenient to complete order transactions without leaving home',
        displayCustomerService: 'Customer',
        joinUS: {
            joinTitle: 'Join us and play and earn together',
            joinText1: 'You only have one way to make money',
            joinText2: 'distance',
            ERPDeployIndependently: 'ERP is deployed independently',
            ERPDeployIndependentlyText: 'Deploy ERP independently without relying on other systems',
            exclusiveCooperation: 'Exclusive cooperation',
            exclusiveCooperationText: 'We will provide a complete system to teach you to produce a customized product',
            trainingCooperation: 'Training cooperation',
            trainingCooperationText: 'Use professional capabilities to provide service providers with leading, safe, reliable, and unimaginable products',
        },
        boutiqueRelease: {
            boutiqueReleaseTitle: 'The release of trendy boutiques follows the hot sale in the market',
            boutiqueReleaseText: 'Pursue the optimal solution of flexible supply chain and support OEM',
            name:'name',
            price:'price'
        },
        categoryRich: {
            categoryRichTitle: 'Rich categories',
            categoryRichText: 'Our products are rich in categories to meet the needs of different customers',
            viewMore: 'Read more',
            productMaterial:'Product material',
            productWeight:'Product weight',
            productSize:'Product size',
            goToDesign:'Go to design'
        },
        deployIndependently: {
            deployIndependentlyTitle: 'The system is deployed independently and one-stop flexible customization',
            deployIndependentlyText: 'Customized sharing and win-win ecology',
            contentText1: 'Access your own logistics account',
            contentText2: 'Independent brand design/listing/ordering system',
            contentText3: 'Personalized customized production system',
            contentText4: 'Own factory products are connected to build an internal production line',
            contentText5: 'Separate domain name/independent template/independent product output',
            contentText6: 'One-stop quality inspection and ordering system',
        },
        logisticsCooperation: {
            logisticsCooperationTitle: 'Sold on major e-commerce platforms around the world',
            logisticsCooperationTitle1: 'Logistics cooperation',
        },
        page_document: {
            contactUs: 'contactUs',
            serviceHotline: 'National unified service hotline',
            MondayToSaturday: 'Monday to Saturday',
            contactCustomerService: 'Contact customer service',
            addCustomerService: 'Scan the code to add exclusive customer service',
        },
    },

    login: {
        login: 'login',
        username: 'username',
        password: 'password',
        rememberMe: 'rememberMe',
        register: 'register',
        resetPassword: 'resetPassword',
        returnHome: 'returnHome',
        agreeToTerms: 'agreeToTerms',
        termsOfUse: 'termsOfUse',
        privacyPolicy: 'privacyPolicy',
        pleaseEnterPhoneNumber: 'pleaseEnterPhoneNumber',
        pleaseEnterVerificationCode: 'pleaseEnterVerificationCode',
        getVerificationCode: 'getVerificationCode',
        unregisteredWillCreateAccount: 'unregisteredWillCreateAccount',
        pleaseEnterUsername: 'pleaseEnterUsername',
        pleaseEnterPassword: 'pleaseEnterPassword',
        pleaseDragSliderToRight: 'pleaseDragSliderToRight',
        verifySuccess: 'verifySuccess',
        holdToSlideContinue: 'holdToSlideContinue',
        loginSuccess: 'Login success',
        pleaseCompleteSlider: 'Please complete the slider verification to log in',
    },

    shop_list:{
        shopList: 'Selection library',
        productName: 'Product name',
        productSKU: 'Product SKU',
        shopPrice: 'From ￥{ price }',
        shippingArea: 'Shipping area',
        domesticShipping: 'Domestic shipping',
        internationalShipping: 'International shipping',
        addNewProductDemand: 'Add new product demand',
        imageException: 'Image exception',
        expectDelivery: 'Expect delivery',
        expectDeliveryTime: '2-4 days delivery',
        titleName: 'Title name',
        selectTaskTemplate: 'Select task template',
        shop: 'Selection',
        selectEffectImage: 'Select effect image',
        templateImage: 'Template image',
        productReferenceLink: 'Product reference link',
        factoryPriceDemand: 'Factory price demand',
        fabricMaterialDemand: 'Fabric material demand',
        remark: 'Remark',
        allCategory: 'All categories',
    },

    customs: {
        selectCustoms: 'Customs selection',
        customCustomsInfo: 'Custom Customs Information',
        selectProductName: 'Select product name',
        selectProductNumber: 'Select product number',
        productId: 'Product ID',
        addProductCustomsInfo: 'Add product customs information',
        customsTip: 'Platform preset product customs information, agent declare order. If the user is responsible for the loss or damage caused by the declaration of tariff or the detention of goods by customs, the user is responsible for the loss or damage caused by the declaration of tariff or the detention of goods by customs.',
        declareChineseName: 'Declare Chinese name',
        size: 'Size',
        declareEnglishName: 'Declare English name',
        productMaterialEnglish: 'Product material (English)',
        declarePriceUSD: 'Declare price (USD)',
        declareWeightG: 'Declare weight (g)',
        customsCode: 'Customs code',
        operation: 'Operation',
        addNewCustomsProduct: 'Add new customs product',

        editCustomsInfo: 'Edit customs information',
        confirmDeleteCustomsInfo: 'Delete customs information, the selected product will be restored to default, continue?',
        productName: 'Product name',
        productSku: 'Product SKU',
        templateCategory: 'Template category',
        addNewCustomsInfo: 'Add new customs information',
        selectAll: 'Select all',
        imageException: 'Image exception',
        productAddCustomsInfo: 'Add customs information for selected products',
        batchImport: 'Batch import',
        batchEdit: 'Batch edit',
        country: 'Country',
    },

    theme_requi:{
        selection: 'Selection',
        themeRequirement: 'Theme requirement',
        themeName: 'Theme name',
        creator: 'Creator',
        elementProductionMethod: 'Element production method',
        behalfOthers: 'Behalf others',
        makeYourOwn: 'Make your own',
        themeImage: 'Theme image',
        completionStatus: 'Completion status',
        pendDevelopment: 'Pending development',
        subThemeCompleted: 'Sub-theme development completed',
        elementCompleted: 'Element production completed',
        completed: 'Completed',
        remark: 'Remark',
        viewRemark: 'View theme remark',
        viewSubTheme: 'View sub-theme',
        operation: 'Operation',
        subThemeDownload: 'Sub-theme download',
        themeRemark: 'Theme remark',
        subThemeInfo: 'Sub-theme information',
        feeExplanation: 'Fee explanation',
        themeNameExplanation: 'Theme name explanation',
        howMade: 'How made',
        madeTip: 'Pending development as designer to make elements (fee standard above)',
        behalfOthersTip: 'Please note, the operation of behalf others is a fee operation, please refer to the above fee explanation for details',
        notice: 'Notice',
        title: 'Title',
        subThemeImage: 'Sub-theme image',
    },

    product_list: {
        productManagement: 'Product management',
        myProducts: 'My products',
        pendingGeneratedProducts: 'Pending generated products',
        productName: 'Product name',
        selectionSKU: 'Selection SKU',
        operator: 'Operator',
        platformSKU: 'Platform SKU',
        designSKU: 'Design SKU',
        designer: 'Designer',
        productNumber: 'Product number',
        englishTheme: 'English theme',
        selectSubAccount: 'Select sub-account',
        selectAll: 'Select all',
        selectProductTemplate: 'Please select product template',
        exportStatus: 'Export status',
        exported: 'Exported',
        notExported: 'Not exported',
        compositeProduct: 'Composite product',
        unsold: 'Unsold',
        productBasicInfo: 'Product basic information',
        viewCompositeProduct: 'View composite product',
        shippingCenter: 'Shipping center',
        tags: 'Tags',
        finishedSKU: 'Finished SKU',
        attachedImages: 'Attached images',
        generating: 'Generating',
        boundPlatformShopSKU: 'Bound platform/shop/SKU',
        platformShop: 'Platform/shop',
        unbind: 'Unbind',
        viewAll: 'View all',
        createTime: 'Create time',
        productDetail: 'Product detail',
        productEdit: 'Product edit',
        addToCart: 'Add to cart',
        moreOperation: 'More operation',
        downloadHighDefinition: 'Download high definition',
        associateShop: 'Associate shop',
        exportProduct: 'Product export',
        manualAssociation: 'Manual association',
        amazonExport: 'Amazon export',
        walmartExport: 'Walmart export',
        ebayExport: 'Ebay export',
        compositeProductInfo: 'Composite product information',
        compositeProductInfoTips: 'Different factories cannot be combined',
        batchExportTips: 'Batch export must belong to the same template, and the same template sku',
        cannotAddToCart: 'Finished products cannot be added to the cart',
        noPermission: 'You do not have permission to operate the selected elements',
        confirmDeleteProducts: 'Delete my products, continue?',
        confirmUnbind: 'Confirm unbind, continue?',
        englishTags: 'English label',
        importantInformation: 'Important information',
        optionalInformation: 'Optional information',
        pleaseSelectSize: 'Please select size',
        englishTagsTips: 'English label separated by commas',
        updateTime: 'Update time',
        productElement: 'Product element',
        previewImageException: 'Sorry, preview image loading failed',
        noData: 'No data',
        productImage: 'Product image',
        platformShopSKU: 'Platform/shop/SKU',
        originalImage: 'Original',
        addNewShop: 'Add new shop',
        SKURules: 'SKU rules',
        SKURandomCharacter: 'SKU random character',
        exportProductImage: 'Export product image',
        pleaseSelectShop: 'Please select shop',
        pleaseInputSKU: 'Please input SKU (case sensitive)',
        exportTip: "1. When uploading pictures and/or text, there must be no illegal acts related to politics, pornography, infringement, etc., and the circumstances will be banned, thank you for your cooperation.",
        exportTip2: "2.If the filling fields are inconsistent with Amazon, please go to the Amazon store to download the latest template import again, and be sure to select a single country when downloading the template.",
        exportProducts: 'Export products',
        shop: 'Shop',
        mainImage: 'Main image',
        setMainImage: 'Set as main image',
        removeImage: 'Remove',
        importantInfo: 'Important information',
        brand: 'Brand',
        factory: 'Factory',
        externalProductNumberType: 'External product number type',
        retailPrice: 'Retail price',
        stock: 'Stock',
        optionalInfo: 'Optional information',
        exportTemplate: 'Export template',
        productTemplate: 'Product template',
        remark: 'Remark',
        productImageTips: 'Click to drag the image to adjust the order of the images! Each variant will export the pictures separately in the following order',
        sellingForm: 'Sales form',
        singleProduct: 'Single item',
        sizeVariant: 'Size variant',
        colorVariant: 'Color variant',
        productVariant: 'Product variant',
        productVariantTips: 'Export multiple custom products into 1 parent product according to the "Merge quantity" setting.',
        colorVariantTips: 'To ensure color uniqueness, the same color will be fixed with a sequence number when exporting.',
        sizeVariantTips: 'Specify the size to export',
        blankProductName: 'Blank product name',
        size: 'Size',
        attributeCombination: 'Attribute combination',
        namePlusSize: 'Name plus size',
        open: 'open',
        close: 'close',
        openTips: 'Open after export, the product name will automatically add size information',
        insertVariable: 'Insert variable',
        name: 'Name',
        variable: 'Variable',
        declaration: 'Declaration',
        preview: 'Preview',
        longDescription: 'Long description',
        sizePrice: 'Size price($)',
        priceSyncToSize: 'Price sync to size',
        price: 'Price($)',
        fillNumber: 'Fill number',
        fillNumberTips: 'Multiple fill numbers need to be entered line by line in the box',
        SKUQuantityTip:"*{ count1} is required, {count2} has been entered. If there are less than {count3}, the exported product number will be empty, and if the required number is exceeded, the system will automatically ignore it.",
        inventory: 'inventory',
        shortDescription1: 'Short description 1',
        shortDescription2: 'Short description 2',
        shortDescription3: 'Short description 3',
        saveTemplate: 'Save the template',
        previewVariable: 'Preview variable',
        pleaseInputVariableValue: 'Please input variable value',
        color: 'Color',
        quantity: 'Quantity',
        addToCartQuantity: 'Add to cart quantity',
        maxAddToCartQuantityTips: 'Maximum add to cart quantity is { max_nums }, please contact customer service if you want to add more',
        unitPrice: 'Unit price($)',
        viewCart: 'View cart',
        fullEntry: 'Please enter the size and quantity information of the product in full',
        productInfo: 'Product information',
        compositeProductName: 'Composite product name',
        notEnterCompositeProductNameTips: 'If you do not enter the composite product name, the first composite product name will be used by default',
        batchEdit: 'Batch edit',
        batchDelete: 'Batch delete',
        batchDownload: 'Batch download',
        productExport: 'Product export',
        walmartPlatformExport: 'Walmart platform export',
        amazonPlatformExport: 'Amazon platform export',
        combinationProducts: 'Combination products',
        user_name: 'Owner',
    },

    wrmTemplate:{
        productLibrary: 'Product library',
        exportProductTemplate: 'Export product template',
        templateName: 'Template name',
        createStartTime: 'Create start time',
        createEndTime: 'Create end time',
        templateType: 'Template type',
        walmart: 'Walmart',
        attributeCombination: 'Attribute combination',
        createTime: 'Create time',
        deleteExportTemplateConfirm: 'Delete export template confirm?',
    },

    bank: {
        imageCategory: 'Image category',
        materialLibrary: 'Stock Library',
        myGallery: 'My gallery',
        englishName: 'English name',
        chineseName: 'Chinese name',
        englishTag: 'English tag',
        ID: 'ID',
        pleaseSelectSubAccount: 'Please select sub account',
        createStartTime: 'Create start time',
        createEndTime: 'Create end time',
        material: 'Material',
        noticeDisableWord: 'Notice disable word',
        shareToAllPlatform: 'Share to all platform',
        specification: 'Specification',
        imagePixel: 'Image pixel',
        imageType: 'Image type',
        themeImage: 'Theme image',
        backgroundImage: 'Background image',
        source: 'Source',
        createTime: 'Create time',
        operation: 'Operation',
        uploadElement: 'Upload element',
        editCategory: 'Edit category',
        editTag: 'Edit tag',
        editImageInfo: 'Edit image info',
        shareImage: 'Share image',
        noPermission: 'You do not have permission to operate the selected element',
        batchDeleteConfirm: 'Delete image, continue?',
        uploadTips1: 'Drag and drop the image here to upload, or click upload',
        uploadTips2: 'To ensure the normal use of the image, only jpg, jpeg, png format images within 30M are supported for upload. Multiple images can be uploaded at once',
        uploadTips3: 'Uploading images or text must not contain any illegal content such as politics, pornography, infringement, etc. Serious violations will be punished with account suspension. Thank you for your cooperation.',
        uploadTips4: 'Only jpg, jpeg, png format images within 30M are supported for upload',
        selectedImageMaterial: 'Selected image material',
        materialCategory: 'Material category',
        addTag: 'Add tag',
        englishTheme: 'English theme',
        englishThemeTips: 'English theme is the element theme keyword',
        oneKeyEnterImageInfo: 'One key enter image info',
        setCategory: 'Set category',
        oneKeySync: 'One key sync',
        uploadImageInfo: 'Upload image info',
        img: "Image",
        uploadFailedImageInfo: 'Upload failed image info',
        reason: 'Failure reason',
        imageSizeTips: 'Image size exceeds 30M, please upload a smaller image',
        shareAccount: 'Share account',
        uploadImage: 'Upload an image',
        changeTag: 'Change tag',
        deleteImage: 'Delete image',
        imageSize: 'Image size',
        allCategory: 'All categories',
        deleteCategoryConfirm: 'Delete category confirm?',
    },

    forbidden_word:{
        prohibitedWords: 'Prohibited words',
        localWordLibrary: 'Local word library',
        cloudWordLibrary: 'Cloud word library',
        serialNumber: 'Serial number',
        riskLevel: 'Risk level',
        applicablePlatform: 'Applicable platform',
        remark: 'Remark',
        schematicDiagram: 'Schematic diagram',
        createPerson: 'Create person',
        deleteForbiddenWordConfirm: 'Delete forbidden word confirm?',
        inputForbiddenWord: 'Input forbidden word',
        inputForbiddenWordTips: 'Input completed, press enter to generate tag',
        lowRisk: 'Low risk',
        mediumRisk: 'Medium risk',
        highRisk: 'High risk',
        allPlatform: 'All platforms',
        specifiedPlatform: 'Specified platform',
        addToCloudWordLibrary: 'Add to cloud word library',
        pleaseAddRemark: 'Please add remark',
        schematicDiagramTips: 'Only one image is supported, the format is PNG, JPG, and the size cannot exceed 10M',
        uploadImageTips: 'Upload image schematic',
        pleaseAddRemarkTips: 'Please enter the forbidden word library after pressing enter to add',
        onlySupportJpgPngFormat: 'Only support jpg, png format image upload',
        imageSizeTips: 'Only support image size within 10M upload',
        emptyTagTips: 'Forbidden word library tag is empty, please confirm that the forbidden word library has been entered, and the tag has been generated after pressing enter',
        commonData: 'Common data',
        goRelevantPage: 'Click to go to the relevant page',
        myGallery: 'My gallery',
        material: 'Material',
        forbiddenWordLibrary: 'Forbidden word library',
    },

    single_element: {
        gallery: 'Single element gallery',
        exportGallery: 'Export single element gallery',
        exportNum: 'Export number',
        material: 'Material',
        materialName: 'Material name',
        designSKU: 'Design SKU',
        specification: 'Specification',
        imagePixel: 'Image pixel',
        imageSize: 'Image size',
        exportProduct: 'Export single element product',
        viewOrder: 'View order',
        order: 'Order',
        productKeywords: 'Product keywords',
        productSKU: 'Product SKU',
        productCode: 'Product code',
        operator: 'Operator',
        platformSKU: 'Platform SKU',
        productImage: 'Product image',
        attachments: 'Attachments',
        themeNameEnglish: 'Theme name (English)',
        tags: 'Tags',
        orderNumber: 'Order number',
        platformShopOperator: 'Platform/shop/operator',
        productNum: 'Product number',
        source: 'Source',
    },

    workList: {
        workOrder: 'Work order',
        workOrderManagement: 'Work order management',
        workOrderTitle: 'Work order title',
        selectWorkOrderStatus: 'Select work order status',
        pending: 'Pending',
        developed: 'Developed',
        developing: 'Developing',
        completed: 'Completed',
        canceled: 'Canceled',
        addWorkOrder: 'Add work order',
        urgent: 'Urgent',
        open: 'Open',
        close: 'Close',
        status: 'Status',
        expectCompleteTime: 'Expect complete time',
        actualCompleteTime: 'Actual complete time',
        workOrderDescription: 'Work order description',
        cancelWorkOrder: 'Cancel work order',
        detailedDescription: 'Detailed description',
        cancelWorkOrderConfirm: 'Cancel work order confirm?',
        commentContent: 'Comment content',
        commentUser: 'Comment user',
        commentTime: 'Comment time',
    },

    deal_record:{
        statistics:'data',
        transactionNumber:'Transaction number',
        platformOrderNumber:'Platform order number',
        factoryOrderNumber:'Factory order number',
        transactionType:'Transaction type',
        selectSubAccount:'Select sub account',
        transactionStartTime:'Transaction start time',
        transactionEndTime:'Transaction end time',
        exportTransactionRecord:'Export transaction record',
        accountRecharge:'Account recharge',
        systemOrderNumber:'System order number',
        transactionRecord:'Transaction record',
        amount:'Amount (yuan)',
        arrivalTime:'Arrival time',
        createTime:'Create time',
        balance: 'Balance（yuan）',
        cumulativeRecharge:'Cumulative recharge（yuan）',
        cumulativeExpenditure:'Cumulative expenditure（yuan）',
        cumulativeCommission:'Cumulative commission（yuan）',
        commissionDetails:'Commission details',
        orderCommission:'Order commission（yuan）',
        logisticsCommission:'Logistics commission（yuan）',
    },

    distribution_data:{
        statistics:'Data',
        distributionData:'Distribution data',
        transactionStartTime:'Transaction start time',
        transactionEndTime:'Transaction end time',
        totalSalesAmount:'Total sales amount（yuan）',
        totalProfit:'Total profit（yuan）',
        companyName:'Company name',
        shippingChannel:'Shipping channel',
        distributionFee:'Distribution fee（yuan）',
        createTime:'Create time',
        distributorTotalSalesAmount:'Distributor total sales amount（yuan）',
        distributorTotalProfitRatio:'Distributor total profit ratio（%）',
    },

    order_data:{
        statistics:'Data',
        orderData:'Order data',
        statisticsType:'Statistics type (dimension)',
        date:'Date',
        shop:'Shop',
        finishedProduct:'Finished product',
        selectedProduct:'Selected product',
        platform:'Platform',
        subAccount:'Sub account',
        orderStatus:'Order status',
        totalSalesAmount:'Total sales amount（$）',
        totalOrderNum:'Total order number',
        totalOrderItemNum:'Total order item number',
        averagePricePerItem:'Average price per item（$）',
        orderNum:'Order number',
        orderItemNum:'Order item number',
        averageSalesPerItem:'Average sales per item（$）',
    },

    product_data:{
        statistics:'Data',
        productData:'Product data',
        startTime:'Start time',
        endTime:'End time',
        productStatistics:"Custom product data statistics (total { count } items)",
        rank:'Rank',
        productNum:'Custom product number',
        account:'Account',
        viewProductDetail:'View product details',
    },

    design_record: {
        productLibrary: 'Product library',
        designRecord: 'Design record',
        customSKU: 'Custom SKU',
        user: 'User',
        templateTitle: 'Template title',
        pass: 'Pass',
        notPass: 'Not pass',
        generated: 'Generated',
        waitAudit: 'Wait audit',
        generating: 'Generating',
        from: 'From',
        designLibrary: 'Design library',
        order: 'Order',
        serialNumber: 'Serial number',
        templateSKU: 'Template SKU',
        status: 'Status',
        userDesignImg: 'User design image',
        effectImg: 'Effect image data',
        operation: 'Operation',
        createTime: 'Create time',
        designAudit: 'Design audit',
        regenerate: 'Regenerate',
        deleteDesign: 'Delete design',
        auditDesignRecord: 'Audit design record',
    },

    tuku_data:{
        statistics:'Data',
        tukuStatistics:'Image upload quantity statistics',
        subAccount:'Sub-account',
        imgStatistics:'Statistics on the number of images uploaded ({ count } in total)',
        rank:'ranking',
        uploadNum:'Upload quantity',
        uploadAccount:'Upload account',
    },

    com_cash:{
        statistics:'Data',
        withdrawalRecords:'Withdrawal records',
        inputOrderNumber:'Input order number',
        commissionType:'Commission type',
        orderCommission:'Order commission',
        logisticsCommission:'Logistics commission',
        logisticsReturnFee:'Logistics return fee',
        withdrawalType:'Withdrawal type',
        alipay:'Alipay',
        bankCard:'Bank card',
        wechat:'Wechat',
        balance:'Balance',
        currentStatus:'Current status',
        pendingReview:'Pending review',
        reviewPassed:'Review passed',
        reviewRejected:'Review rejected',
        paid:'Paid',
        transactionStartTime:'Transaction start time',
        transactionEndTime:'Transaction end time',
        totalCommissionBalance:'Total commission balance：{count} yuan',
        orderCommissionBalance:'Order commission balance：{count} yuan',
        logisticsCommissionBalance:'Logistics commission balance：{count} yuan',
        orderNumber:'Order number',
        withdrawAmount:'Withdrawal amount（yuan）',
        withdrawalAccount:'Withdrawal account',
        remark:'Remark',
        createTime:'Create time',
    },

    frozen_list: {
        systemOrderNumber: 'System order number',
        statistics: 'Frozen data',
        frozenAmount: 'Frozen amount',
        platformOrderNumber: 'Platform order number',
        factoryOrderNumber: 'Factory order number',
        transactionType: 'Transaction type',
        factoryProductionFee: 'Factory production fee',
        logisticsFee: 'Logistics fee',
        transactionStartTime: 'Transaction start time',
        transactionEndTime: 'Transaction end time',
        exportFrozenList: 'Export',
        totalFreezeAmount: 'Total frozen amount：{count} yuan',
        productionFeeFrozen: 'Factory production fee frozen amount：{count} yuan',
        logisticsFeeFrozen: 'Logistics fee frozen amount：{count} yuan',
        frozenQuantity: 'Frozen quantity',
        operator: 'operator',
        operationTime: 'Operating time',
    },

    allProducts: {
        searchTips: 'Platform featured, quality guaranteed, featured products',
        explore: 'explore',
        imageException: 'The picture is abnormal',
        craft:'craft',
        material:'material',
        sizeNum:'Size number',
        weight:'Weight',
        category:'Category',
        expectDeliveryTime:'Expected delivery time',
        topicZone:'Topic zone',
        allCategory:'All categories',
    },

    shopDetail: {
        salesPromotion:'This item is on sale',
        endTime:'Until then',
        month:'month',
        day:'day',
        productPriceException:'The price of the product is abnormal, please contact customer service!',
        shippingTips:'The delivery time is related to the number of pieces and is subject to the actual delivery time',
        noSizeWeightInfo:'No size and weight information yet!',
        weightIncludePackaging:'Weight (including packaging)',
        shippingCenter:'Fulfillment center',
        viewAddress:'View address',
        color:'color',
        size:'Size',
        priceTip:'Due to the different production costs of different colors and sizes of current goods, their unit prices will also be different',
        noSizeInfo:'No size information available！',
        amazonSameProduct:'Same product on Amazon',
        design:'I want to design',
        basicInfo:'Basic information',
        otherDescription:'Other descriptions',
        designDescription:'Design description',
        sizeInfo:'Size information',
        packageInfo:'Packaging information',
        name:'name',
        englishName:'English name',
        productCode:'Product Code',
        productMaterial:'Product material',
        productCraft:'Product craft',
        factory:'Factory',
        shippingTime:'Shipping time',
        hour:'hour',
        notice:'Notice',
        noticeText:'The effect shown in this picture is for reference only, and the final effect is subject to the actual product! Due to objective factors such as production batches and machinery and equipment, it is difficult to avoid or there will be errors such as slight color difference, position and size.',
        materialDescription:'Material description',
        accessoryConstruction:'Accessory construction',
        productPerformance:'Product performance',
        applicableScenarios:'Applicable scenarios',
        washDescription:'Wash description',
        specialNotice:'Special notice',
        designArea:'Design area',
        imageRequirements:'Image requirements',
        packageSizeCm:'Package Size (cm)',
        lengthWidthHeight:'(L*W*H)',
        packageSizeIn:'Package Size (in)',
        packageVolumeCm3:'Packing volume (cm³)',
        packageVolumeIn3:'Packing volume (in³)',
        weightIncludePackagingG:'Weight (including packaging) (g)',
        weightIncludePackagingLb:'Weight (including packaging) (lb)',
        orderNow: "Order now, estimated delivery in {time} hours",
        costCalculation:'Cost calculation',
        packingName: 'Packing name',
    },

    order: {
        order:'Order',
        myOrder:'My orders',
        orderExpiration:'Orders over 30 days without processing will be automatically cancelled',
        authorizationExpires:'{ expired_nums } store authorizations have expired',
        auditApplicationDesign:'Audit application design',
        mergeOrderList:'Mergeable shipping list',
        multipleSearchItems:'Multiple search items please separate with commas or enter keys, up to 100 items',
        clear:'Clear',
        close:'Close',
        search:'Search',
        preciseSearches:'Precise searches',
        systemOrderNumber:'System order number',
        platformOrderNumber:'Platform order number',
        orderProductName:'Order product name',
        createUser:'Create user',
        operator:'Operator',
        designer:'Designer',
        reDesign: 'redesign',
        customSKU:'Custom SKU',
        customOrderDetails:'Custom order details',
        thirdPartyLogistics:'Third-party logistics',
        walmartPurchaseNumber:'Walmart purchase number',
        mergeBatchNumber:'Merge batch number',
        selectSubAccount:'Select sub-account',
        all:'All',
        pleaseSelectCraft:'Please select craft',
        logisticsMergeInfo:'Logistics merge information',
        logisticsNotMerged:'Logistics not merged',
        logisticsMerged:'Logistics merged',
        choose:'Please choose',
        importDate:'Import date',
        platformOrderTime:'Platform order time',
        platformShippingTime:'Platform shipping time',
        updateTime:'Update time',
        systemShippingTime:'System shipping time',
        startTime:'Start time',
        endTime:'End time',
        to:'To',
        pleaseSelectPlatform:'Please select platform',
        pleaseSelectStore:'Please select store',
        whetherHasLabel:'Whether has label',
        hasLabel:'Has label',
        noLabel:'No label',
        noImage:'No image',
        productName:'Product name',
        SKUItemNumber:'SKU item number',
        specification:'Specification',
        quantity:'Quantity',
        associatedProducts:'Associated products',
        exceptionOrderProducts:'Exception order products',
        compositeProducts:'Composite products',
        designInProcess:'Design in process',
        name:'Name',
        price:'Price',
        quantityEdit:'Quantity edit',
        stockUpProductSKU:'Stock up product SKU',
        stockUpInventory:'Stock up inventory',
        productNumber:'Product number',
        compositeProductID:'Composite product ID',
        craft:'Craft',
        size:'Size',
        platformSize:'Platform size',
        status:'Status',
        expectedDeliveryTime:'Expected delivery time',
        customInfo:'Custom information',
        goToDesign:'Go to design',
        modifyAssociated:'Modify associated',
        applyDesign:'Apply design',
        deleteOrderProduct:'Delete order product',
        viewProductionNotes:'View production notes',
        productPayment:'Product payment',
        shippingFee:'Shipping fee',
        frozenShippingFee:'Frozen shipping fee',
        total:'Total',
        profitMargin:'Profit margin',
        contactPerson:'Contact person',
        contactPhone:'Contact phone',
        warehouseAddress:'Warehouse address',
        trackingNumber:'Tracking number',
        shippingDays:'Shipping days',
        deliveryDays:'Delivery days',
        logisticsNotUpdated:'Logistics {days_after_last_update} days not updated',
        logisticsTrack:'Logistics track',
        platformLatestShippingTime:'Platform latest shipping time',
        importSystemTime:'Import system time',
        productPaymentTime:'Product payment time',
        copyOrder:'Copy order',
        createPreShipping:'Create pre-shipping',
        handleException:'Handle exception',
        applyAfterSales:'Apply after-sales',
        getTrackingNumber:'Get tracking number',
        modifyAddress:'Modify address',
        restoreOrder:'Restore order',
        cancelOrder:'Cancel order',
        applyInterception:'Apply interception',
        syncLogistics:'Sync logistics',
        viewLabel:'View label',
        orderDetails:'Order details',
        shippingMethod:'Shipping method',
        FBAShipping:'FBA shipping',
        selfPickup:'Self-pickup',
        suspectedPhishing:'Suspected phishing',
        phishingAddress:'Phishing address',
        shippingCenter:'Shipping center',
        platform:'Platform',
        store:'Store',
        receiver:'Receiver',
        phoneNumber:'Phone number',
        recipient:'Recipient',
        postCode:'Postal code',
        detailedAddress:'Detailed address',
        detailedAddress2:'Detailed address 2',
        salesVolume:'Sales volume',
        logistics:'Logistics',
        time:'Time',
        operation:'Operation',
        createShipping:'Create shipping',
        enterProductionInfo:'Enter production information',
        mergeShipping:'Merge shipping',
        batchCreateShipping:'Batch create shipping',
        importCustomInfo:'Import custom information',
        generateFBAItem:'Generate FBA item',
        modifyProductQuantity:'Modify order product quantity',
        syncFullCustodyShipping:'Sync full custody shipping',
        createOut:'Create out',
        payProductPayment:'Pay product payment',
        batchImportLabels:'Batch import labels',
        importLogisticsNumber:'Import logistics number',
        importOrder:'Import order',
        mergeShipping1:'Merge shipping',
        createFBAItem:'Create FBA item',
        sheinCustomInfo: "Shein custom information",
        temuCustomInfo: "Temu custom information",
        logisticsExport:'Logistics export',
        walmartLogisticsExport:'Walmart logistics export',
        moreOperation:'More operation',
        batchExportOrders:'Batch export orders',
        batchPreShipping:'Batch pre-shipping',
        batchCancelOrder:'Batch cancel order',
        exportShippingCost:'Export shipping cost',
        country:'Country',
        city:'City',
        state:'State',
        mailbox:'Email',
        quantitySelected:'{ count } orders have been selected',
        payableNum:'{ count } orders can be paid',
        unPayableNum:'{ count } orders cannot be paid',
        resultPreview:'Preview results',
        payable:'Payable',
        unPayable:'Unpayable',
        orderNumber:'Order number',
        orderPayment:'Order payment',
        viewDetail:'View detail',
        orderProduct:'Order product',
        unitPrice:'Unit price(￥)',
        totalPayment:'Total payment(￥)',
        orderStatus:'Order status',
        description:'Description',
        paymentMethod:'Payment method',
        accountBalance:'Account balance',
        availableBalance:'Available balance(￥)',
        recharge:'Recharge',
        payableAmount:'Payable amount(￥)',
        pay:'Pay',
        pleaseSelectOrder:'Please select an order to pay',
        orderPaymentException:'Order payment exception, please contact customer service',
        payOrderPayment:'Pay order payment, continue?',
        mergedShippingSameStoreSameAddress:'Merged shipping must be same store and same address',
        orderID:'Order ID',
        platformStore:'Platform store',
        requiredShippingTime:'Required shipping time',
        copyAllOrderID:'Copy all order ID',
        ShippingTimeRequired:'Required shipping time is required',
        Shein:'Shein',
        Temu:'Temu',
        shippingOrderCreateTime:'Shipping order create time',
        endDate:'End date',
        startDate:'Start date',
        whetherCover:'Whether to cover?',
        pleaseSelectSyncTime:'Please select sync time',
        productFnsku:'Product fnsku',
        platformSku:'Platform SKU',
        generateTip:'* For details, please go to FBA = » Shipping List for details',
        pleaseSelectType:'Please select type',
        shipmentInfo:'Shipment information',
        importTrackingNum: 'Import logistics number',
        orderProducts:'Order products',
        systemNoOrderID:'System has no order number',
        systemHasLogisticsNumber:'System has logistics number',
        procedureTip:"Steps: Log in to the background of the third-party platform to download the face order that needs to be shipped, and the face order file is named: platform order number{'@'}waybill number; If the imported order form already contains the tracking number, you can directly name it with the tracking number (if the bill already exists, the newly imported order will cover the original order) USPS Face Sheet Size Recommendation: 4*6inch",
        procedureTip1:'Steps: Download the template and enter the platform order number and logistics order number for import. Then the face order file is named as waybill number.pdf and then continue to upload the face order file',
        goImportLogisticsNumber:'Go import logistics number',
        keywordSearch:'Keyword quick search',
        dragAndDropFile:'Drag and drop the file logistics face sheet PDF file here to upload',
        clickUpload:'Click upload',
        pleaseUploadPDFFile:'Please upload PDF file',
        successfullyImported:'Successfully imported { count } orders',
        failedImport:'Failed to import { count } orders',
        failedReason:'Failure reason',
        pleaseUploadWaybill:'Please upload the face sheet',
        pleaseUploadTxtXlsxXlsFormat:'Please upload .txt, .xlsx, .xls format files',
        pleaseUploadCustomInfoFile:'Please upload custom information file',
        downloadTemplate:'Download template',
        import:'Import',
        pleaseImportLogisticsNumber:'Please import logistics number',
        logisticsChannels:'Logistics channels',
        deliver:'Deliver',
        goChannel:'Go to set up logistics channel',
        logisticsNumber:'Logistics number',
        logisticsWaybill:'Logistics waybill',
        importLogisticsWaybill:'Import logistics waybill',
        pleaseUploadLogisticsWaybill:'Please upload logistics waybill.pdf,.zip format',
        systemAgent:'System agent',
        ownChannel:'Own channel',
        proxyChannel:'Proxy channel',
        confirmDesignComplete: 'The product status is design complete, and the modification of customized information products needs to be redesigned, whether to continue?',
        preShippingCreated:'Pre-shipping created, if you need to modify, please contact the platform customer service',
        orderInfo:'Order information',
        shippingAddress:'Shipping address',
        customsInformation:'Customs information',
        logisticsInformation:'Logistics information',
        transactionInformation:'Transaction information',
        exceptionOrderProduct:'Exception order product',
        combinedProduct:'Combined product',
        orderProductIdentifier:'Order product identifier',
        stock:'Stock',
        combinedProductID:'Combined product ID',
        productionStatus:'Production status',
        goProductionTime:'Go production time',
        deliveryTime:'Delivery time',
        pendingProcessing:'Pending processing',
        designInProgress:'Design in progress',
        designComplete:'Design complete',
        inProduction:'In production',
        qualityInspection:'Quality inspection',
        pendingShipping:'Pending shipping',
        delivered:'Delivered',
        cancelled:'Cancelled',
        shipping:'Shipping',
        remoteAddress: 'Remote address',
        province: 'province',
        pleaseCorrectEmailAddress: 'Please enter the correct email address',
        selectedProductName: 'Selected product name',
        chineseName: 'Chinese name',
        englishName: 'English name',
        material: 'material',
        declarePrice: 'Declared price',
        declareWeight: 'Declared Weight (g)',
        customsCode: 'Customs code',
        remark: 'remark',
        declareRemark: 'The platform presets product customs declaration information and declares orders as an agent. Users are responsible for any disputes/losses arising from customs declarations or customs seizures.',
        declareRemark1: '2. You can customize the customs declaration information of the product,',
        declareRemark2: '(Same blank products, combined declaration)',
        clickGo: 'Click to go',
        createLogisticsNumber: 'Create logistics number',
        recentLogisticsTrack: 'Recent logistics track',
        transactionType: 'Transaction type',
        transactionNumber: 'Transaction number',
        amountInYuan: 'Amount (yuan)',
        factoryOrderNumber: 'Factory order number',
        arrivalTime: 'Arrival time',
        frozenType: 'Frozen type',
        OrderLogisticsFee: 'Order logistics fee',
        frozenQuantity: 'Frozen quantity',
        frozenAmountInYuan: 'Frozen amount (yuan)',
        operationTime: 'Operation time',
        copyOrderConfirm: 'Copy order, do you want to continue?',
        getWaybillNumber: 'Get the parcel number, do you want to continue?',
        deleteOrderProductConfirm: 'Delete order product (if the order has no products, the order will be deleted!), whether to continue?',
        recoverOrderToPendingProcessing: 'Recover order to pending processing, whether to continue?',
        batchCancelOrderConfirm: 'Batch cancel order, whether to continue?',
        syncLogisticsConfirm: 'Sync logistics, whether to continue?',
        syncLogisticsTip: 'The selected items contain non-FBA shipping orders',
        cancelOrderConfirm: 'Are you sure you want to cancel the order?',
        cancelOrderTip: 'The order has been processed, canceling will deduct the factory fee, whether to continue?',
        Y2OrderCancelConfirm: 'Are you sure you want to cancel the Y2 order?',
        synchronousTKFaceSheet: 'Synchronize TK face sheet',
        batchGetTKFaceSheetConfirm: 'Batch get TK face sheet, whether to continue?',
        batchGetTEMUFaceSheetConfirm: 'Batch get TEMU face sheet, whether to continue?',
        reDesignBindProductWillUnbind: 'After redesign, the bound product will be automatically unbound',
        pleaseNote: 'Please note',
        pleaseNoteTip: 'Please complete the product design on the newly opened page, if you close this window in advance, please manually refresh the page after designing.',
        tipsWarmPrompt: 'Warm prompt',
        pleaseNoteTip1: 'If you need to upload a custom invoice, please create it before payment.',
        batchExportProduct: 'Export products in bulk',

        keywordSearches: 'Support up to 100 keyword searches',
        logisticsFiveNotUpdated: 'Logistics has not been updated for five days',
        platformOrder: 'Platform order',
        mergeShippingList: 'Merge shipping list',
        pleaseNoteLogisticsWaybill: 'Please note that the logistics order can only be viewed twice, should it continue?',

        platformSearch: 'Platform search',
        addStore: 'Add store',
        importQuantity: 'Import quantity',
        skipQuantity: 'Skip quantity',
        file: 'File',
        fileDownload: 'File download',
        account: 'Account',
        createTime: 'Create time',
        getTEMUSheetsInBulk: 'Batch get TEMU face sheet',
        getOZONSheetsInBulk: 'Batch get OZON face sheet',
        OZONBulkMarkShipments: 'OZON bulk marks shipments',
        goodsID: 'Goods ID',
        mergeOrder: 'Merge order',
        pleaseSelectSameStoreOrder: 'Please select same store orders',
        mergeOrderConfirm: 'Please note that after merging the order, the merged order will be deleted and cannot be recovered. Continue?',
        splitOrder: 'Split order',
        productQuantity: 'Product quantity',
        splitQuantity: 'Split quantity',
        split: 'Split',
        product: 'Product',
        sizeInfo: 'Size information',
        color: 'Color',
        pleaseSelectColor: 'Please select a color',
        pleaseEnterQuantity: 'Please enter the quantity',
    },

    process: {
        order: 'Order',
        processOrder: 'Process order',
        productionStatus: 'Production status',
        inProduction: 'In production',
        productionComplete: 'Production complete',
        cancel: 'Cancel',
        processedProduct: 'Processed product',
        elementPicture: 'Element picture',
        processedQuantity: 'Processed quantity',
        craft: 'Craft',
        whiteInkTemperingPainting: 'White ink tempering painting',
        chiffonDyeing: 'Chiffon dyeing',
        pasteFabDyeing: 'Paste fabric dyeing',
        knittedCapSeamMarking: 'Knitted cap seam marking',
        status: 'Status',
        remark: 'Remark',
        creator: 'Creator',
    },

    store: {
        storeManagement: 'Store management',
        normalStatus: 'normal',
        disabledStatus: 'disable',
        storeName:'Store name',
        pleaseEnterStoreName: 'Please enter the name of the store',
        pleaseSelectCountry: 'Please select a country',
        authorizationStatus: 'Authorization status',
        addStore: 'New stores',
        editStore:'Edit store',
        storeInfo: 'Store information',
        platform: 'platform',
        status: 'state',
        defaultShippingWarehouse: 'Default shipping warehouse',
        syncInfo: 'Synchronize information',
        delayTimeForOnlineOrders: 'Online order fulfillment delay time',
        productSKUAssociation: 'Product SKU association',
        operator: 'operator',
        createTime: 'Creation time',
        operation: 'operate',
        authorized: 'Authorized',
        unauthorized: 'Unauthorized',
        authorizationException: 'Authorization exception',
        noAuthorizationRequired: 'No authorization required',
        exceptionReason: 'Exception reason',
        reset: 'Reset',
        fullCustody:'Full custody',
        halfCustody:'Half custody',
        email:'Email',
        firstSyncTime:'First synchronization time',
        edit:'edit',
        complianceFile:'Compliance documents',
        shippingConfiguration:'Shipping configuration',
        more:'more',
        licensedByShein:'Licensed by Shein',
        cancelAuthorization:'Cancel authorization',
        shopProducts:'Store merchandise',
        addMallID:'Add mallid',
        delete:'Delete',
        number:'numbering',
        region:'region',
        brand:'brand',
        automaticallySyncOrders:'Automatically sync orders',
        yes:'yes',
        no:'no',
        syncOrderStatus:'Sync order status',
        pendingProcessing:'Pending',
        pendingShipping:'To be shipped',
        ifBoundShippingCenter:'If the fulfillment center is bound, the warehouse is matched according to the fulfillment center, and if there is no binding, the default warehouse is obtained by default',
        pleaseSetWarehouse:'Please set up a repository',
        all:'all',
        continue:'continue',
        cancel:'cancel',
        deleteStoreTip:'If the store cannot be restored after deletion, will it continue?',
        operationSuccess:'The operation was successful',
        cancelAuthorizationTip:'Cancel the store authorization, do you want to continue?',
        product:'product',
        day:'day',
        pleaseSelectPlatform:'Please select a platform',
        hostingMethod:'Hosting method',
        productInventoryToken:'Product inventory token',
        getProductInventoryToken:'Enter the TEMU seller center【Service market - Authorization management】to get the product inventory token',
        getToken:'Get token',
        orderShippingToken:'Order shipping token',
        US:'United States',
        goToSellerCentralUS:'Go to Seller Central United States to get token',
        global:'Global',
        goToSellerCentralGlobal:'Go to Seller Central Global to get token',
        EU:'EU region',
        goToSellerCentralEU:'Go to Seller Central EU region to get token',
        country:'Country',
        affiliatedOperator:'Affiliated operator',
        pleaseSelectOperator:'Please select an affiliated operator',
        storeBrand:'Store brand',
        pleaseEnterStoreBrand:'Please enter the store brand',
        storeEmail:'Store email',
        pleaseEnterStoreEmail:'Please enter the store email',
        pleaseEnterFirstSyncTime:'Please enter the first synchronization time',
        SKUItemNumber:'SKU item number',
        hour:'hour',
        onlineOrderImmediateDelivery:'Online order immediate delivery',
        onlyUseUSPS:'Only USPS is used',
        pleaseEnterCountry:'Please enter the country',
        pleaseSelectStatus:'Please select a status',
        pleaseSelectAutoSyncOrders:'Please select whether to automatically synchronize orders',
        pleaseEnterValidEmail:'Please enter a valid email address',
        pleaseSelectProductSKUAssociation:'Please select product SKU association',
        pleaseSelectOnlineOrderDelayTime:'Please select the online order fulfillment delay time',
        pleaseSelectHostingMethod:'Please select the hosting method',
        pleaseEnterProductInventoryToken:'Please enter the product inventory token',
        pleaseSelectSyncOrderStatus:'Please select the sync order status',
        pleaseDoNotSubmitAgain:'Please do not submit again',
        pleaseEnterOrderShippingToken:'Please enter the order shipping token',
        priceStepGetTip:'[Price step acquisition] Due to some logistics issues, we will arrange a second delivery to address the uncollected problem. The customer is responsible for the cost. Whether to continue?',
        notice:'notice',
        shippingMethod:'Shipping method',
        priceStepGetTip1:'Price tier acquisition (default acquisition of the lowest price channel logistics)',
        priceStepGetTip2:'Since the collection rate of Yanwen is very low, this item will exclude Yanwen Logistics',
        priceStepGetTip3:'Due to some logistics problems due to non-collection, we will arrange to make up for it once, and the problem of non-collection will occur again. Customers are responsible for their own responsibility',
        pleaseEnterKeyword:'Please enter the search keyword',
        productsSKU:'Product SKU',
        relatedProducts:'Related products',
        productName:'Product name',
        unbind:'Unbind',
        unbindProductTip:'Unbind the product, continue?',
        sync:'Synchronization',
        warehouseName:'Warehouse name',
        defaultWarehouse:'Default warehouse',
        warehouseCode:'Warehouse code',
        correspondingShippingFactory:'Corresponding shipping factory',
        setDefault:'Set default',
        setFactory:'Set factory',
        setDefaultWarehouseTip:'Set as default warehouse, continue?',
        TemuSynchronizationTip:'Temu store warehouse synchronization, continue?',
        pleaseEnterMallID:'Please enter mallid',

        TKAuthorization: 'TK authorization',
        warning: 'Warning',
        authorizationTip: 'Considering the login Tik Tok store IP problem, it is best to copy this link to your VPN or third-party browser for operation',
        description: 'Description: If it is a global merchant or a domestic merchant cross-border to the UK, please select',
        description1: 'Asia ---> Chinese mainland and the Hong Kong SAR (Cross-Border only)',
        copy: 'copy',
        close: 'close',
        storeType: 'Authorization Type',
        USCrossBorder: 'United States (Cross Border)',
        PhilippinesCrossBorder: 'local',
        continentalUnitedStates:'United States (Mainland)',
        uploadComplianceFile: 'Upload document',
        factory: 'factory',
        notAmerican: "Not American",
        synchronizeInfo: 'Synchronization information',
        onlineOrderDelayTime: 'Order delay time',
        nationalTip:'The factory is synchronized according to the selected country',

        importOrderTip: 'Please note! Due to changes in the platform order form, please check the order information and address information after importing',
        importMethod: 'Import method',
        importPlatformOrder: 'Import platform order',
        importOfflineOrder: 'Import offline order',
        ImportMethod: 'Import method',
        importOrder: 'Import order',
        FileFormatTip: 'Please upload .txt, .xlsx, .xls format',
        orderImportTemplate: 'Offline transaction order import template.xlsx',
        amazonOrderDownloadPath: 'Amazon Order Dashboard Download Path: Order Report - 》 New Order',
        amazonOrderDownloadConfig: 'Amazon Order Dashboard Download Configuration: Add or delete order report columns, except for Promotions, all others should be checked',
        ebayOrderImportEnglish: 'Import English version of eBay orders',
        bindProductTip: 'If a platform SKU needs to bind multiple different products, please import the order after operation -》 Rebind product',
        pleaseUploadFile: 'Please upload file',
        pleaseEnterStoreNumber: 'Please enter store number',
        pleaseSelectStore: 'Please select store',
        checkImportOrderTip: 'Please check the product information and shipping address information after importing',
        noticeTip: 'Notice',
        confirm: 'I know',
        skipImportTip: 'There are {skip_nums} orders skipped import',

        productAPI: 'Product API',
        productAPIAuthorization: 'Product API Authorization',
        goAuthorization: 'Go Authorization',
        USOrderAPIAuthorization: 'US Order API Authorization',
        EUOrderAPIAuthorization: 'EU Order API Authorization',
        globalOrderAPIAuthorization: 'Global Order API Authorization',
        temuShopType: 'Temu Shop Type',
        fullTruck: 'Full Truck',
        halfTruck: 'Half Truck',
        productToken: 'Product token',
        orderToken: 'Order token',
        authorizationTips:'* Temu generates Access Token valid for 90 days, and re-authorization is required if the key expires;',
        pleaseEnterToken: 'Please enter token',
        ozonAuthorization: 'Ozon authorization',
        wildberriesAuthorization: 'Wildberries authorization',
        userID: 'User ID',
        APIKey: 'API key',

        shopeeAuthorization:'Shopee authorization'
    },

    merge:{
        order: 'Order',
        mergeShippingRecord: 'Consolidate shipment records',
        batchNumber: 'Batch number',
        orderNumber: 'Order number',
        waybillNumber: 'Waybill number',
        operator: 'Operator',
        sheinShippingBatchNumber: 'Shein shipping batch number',
        TEMUShippingBatchNumber: 'TEMU shipping batch number',
        logisticsChannel: 'Logistics channel',
        store: 'Store',
        createTime: 'Create time',
        requireShippingTime: 'Require shipping time',
        againMerge: 'Again merge',
        platformReserveShipping: 'Platform reserve shipping',
        platformShippingBatchNumber: 'Platform shipping batch number',
        againMergeBatchNumber: 'Again merge batch number',
        totalMerge: 'Total merged: { length } orders, total quantity: { total_quantity } pieces',
        orderInfo: 'Order information',
        processQuantity: 'Process/quantity: {render_type}/{quantity} pieces',
        shipments: 'Shipments',
        type: 'Type',
        expressOrder: 'Expedited orders',
        normalOrder: 'Normal orders',
        orderTime: 'Order time',
        requireLatestShippingTime: 'Require latest shipping time',
        deliveryDate: 'Delivery date',
        viewAll: 'View all',
        operationInfo: 'Operation information',
        platform: 'Platform',
        creator:'Operator',
        userInfo: 'User information',
        userName: 'User name',
        email: 'Email',
        recipient: 'Recipient',
        addressInfo: 'Address information',
        time: 'Time',
        operation: 'Operation',
        cancelAgainMerge: 'Cancel again merge',
        cancelMerge: 'Cancel merge',
        uploadTEMUExpressFile: 'Upload TEMU expedited file',
        pleaseSelectOrder: 'Please select the order',
        cancelAgainMergeConfirm: 'Cancel again merge, continue?',
        mergeBatchConfirm: 'Merge batch, continue?',
        cancelMergeShippingConfirm: 'Cancel merge shipping, continue?',
        uploadFiles: 'Upload files',
        temuExpressFile: 'TEMU expedited file',
        pleaseUploadPdfFormat: 'Please upload .pdf format file',
        reservePickupTime: 'Reserve pickup time',
        suggestReservePickupTime: 'Suggest reserve pickup time set before { latest_ship_date }',
        packageTotalQuantity: 'Total quantity of packages',
        packageWeight: 'Weight (kg)',
        estimatedWeight: 'Estimated weight: { estimated_weight }kg',
        logisticsCompany: 'Logistics company',
        estimatedFee: 'Estimated fee',
        query: 'Query',
    },

    intercept_order: {
        order: 'Intercept order',
        logisticsInterception: 'Logistics interception',
        orderNumber: 'Order number',
        status: 'Status',
        pending: 'Pending',
        interceptionSuccess: 'Interception success',
        interceptionFailed: 'Interception failed',
        completed: 'Completed',
        applyStartTime: 'Apply start time',
        applyEndTime: 'Apply end time',
        processingMethod: 'Processing method',
        factoryDestroy: 'Factory destroy',
        returnToSpecifiedAddress: 'Return to specified address',
        viewAddress: 'View address',
        logisticsNumber: 'Logistics number',
        logisticsFee: 'Logistics fee',
        applyPerson: 'Apply person',
        applyInterceptionTime: 'Apply interception time',
        operation: 'Operation',
        log: 'Log',
        pleaseSelectStatus: 'Please select status',
        cancelSuccess: 'Cancel interception success',
        cancelFailed: 'Cancel interception failed',
        pleaseSelectProcessingMethod: 'Please select processing method',
        interceptionSuccessQuantity: 'Interception success quantity',
        interceptionFailedQuantity: 'Interception failed quantity',
        cancelInterception: 'Cancel interception',
        interceptionProgress: 'Interception progress',
        cancelInterceptionConfirm: 'Cancel interception, continue?',

        date: 'Date',
        userName: 'User name',
        progress: 'Progress',
    },

    temu_custom: {
        order: 'Order',
        importTEMUCustomInfo: 'Import TEMU customization information',
        importCustomInfoZip: 'Import customization information (Zip)',
        importCustomInfoExcel: 'Import customization information (Excel)',
        status: 'Status',
        unparsed: 'Unparsed',
        parsed: 'Parsed',
        store: 'Store',
        file: 'File',
        fileDownload: 'File download',
        operation: 'Operation',
        analysisCustomization: 'Analysis customization',
        importCustomInfo: 'Import customization information',
    },

    afterSalesList:{
        order: 'Order',
        afterSalesManagement: 'After sales management',
        orderNumber: 'Order number',
        afterSalesType: 'After sales type',
        refund: 'Refund',
        returnRefund: 'Return refund',
        resend: 'Resend',
        pending: 'Pending',
        confirmed: 'Confirmed',
        completed: 'Completed',
        auditPassed: 'Audit passed',
        auditRejected: 'Audit rejected',
        afterSalesOrderInfo: 'After sales order information',
        productName: 'Product name',
        productImage: 'Product image',
        afterSalesAmount: 'After sales amount (yuan)',
        applyAfterSalesAmount: 'Apply after sales amount',
        actualAfterSalesAmount: 'Actual after sales amount',
        afterSalesReason: 'After sales reason',
        afterSalesInstruction: 'After sales instruction',
        submitPerson: 'Submit person',
        updateTime: 'Update time',
        operation: 'Operation',
        view: 'View',
        viewAfterSalesDetail: 'View after sales detail',
    },

    blackList:{
        blackList: 'Blacklist',
        addressBlacklist: 'Address blacklist',
        clientBlacklist: 'Client blacklist',
        ruleName: 'Rule name',
        contain: 'Contain',
        equal: 'Equal',
        operationInfo: 'Operation information',
        operationPerson: 'Operation person',
        createInfo: 'Create information',
        createPerson: 'Create person',
        embodyTip: 'Contain: just need to match one of the phrases, Equal: must match all phrases',
        blackListAddTip: 'Blacklist entry is complete, please click the Enter key to add',
        tagAddTip: 'Tag entry is complete, please click the Enter key to add',
        remark: 'Remark',
        provinceState: 'Province/State',
        city: 'City',
        address: 'Address',
        postcode: 'Postcode',
        store: 'Store',
    },

    main:{
        salesDataOverview:'Sales data overview',
        lastLoginLocation:'Last login location',
        lastLoginTime:'Last login time',
        todoItems:'To do items',
        recent7DaysMetrics:'Recent 7 days product behavior metrics',
        recommend:'Recommend',
        changePassword:'Change password',
        todaySales:'Today sales',
        orderCount:'Order count',
        yesterdaySales:'Yesterday sales',
        thisWeekSales:'This week sales',
        thisMonthSales:'This month sales',
        itemCount:'Item count',
        all:'All',
        noNotification:'There is no announcement yet',
        hotRecommend: 'Hot recommend',
        newProductDelivery: 'New product delivery',
        hotSales: 'Hot sales',

        viewDetail: 'View detail',
        newProduct: 'New product',
        shippingCenter: 'Shipping center',

        designProductQuantity: 'Design product quantity',
        designCategoryQuantity: 'Design category quantity',
        elementUploadQuantity: 'Element upload quantity',
        designOrderEfficiency: 'Design order efficiency',
        categoryOrderEfficiency: 'Category order efficiency',
        elementOrderEfficiency: 'Element order efficiency',
    },

    acInfo: {
        myAccount: 'My Account',
        shippingMethod: 'Shipping method',
        downloadCenter: 'Download center',
        roleManagement: 'Role management',
        subAccountSetting: 'Sub account setting',
        myDistribution: 'My distribution',
        senderInfo: 'Sender information',
        userNumber: 'User number',
        accountNumber: 'Account number',
        changePassword: 'Change password',
        phone: 'Phone',
        balance: 'Balance',
        recharge: 'Recharge',
        withdraw: 'Withdraw',
        commission: 'Commission',
        orderCommission: 'Order commission',
        shippingCommission: 'Shipping commission',
        shippingReturn: 'Shipping return',
        withdrawInfo: 'Withdraw information',
        shippingAddress: 'Shipping address',
        name: 'Name',
        defaultAddress: 'Default address',
        country: 'Country',
        state: 'State/Province',
        city: 'City',
        area: 'Area',
        street: 'Street',
        postcode: 'Postcode',
        mobilePhone: 'Mobile phone',
        addressDetail: 'Detailed address',
        editAddress: 'Edit address',
        default: 'Default',
        systemChannel: 'System channel',
        ownChannel: 'Own channel',
        proxyChannel: 'Proxy channel',
        view: 'View',
        contactWay: 'Contact way',
        open: 'Open',
        close: 'Close',
        operator: 'Operator',
        selectStatus: 'Select status',
        generating: 'Generating',
        generated: 'Generated',
        generateFailed: 'Generate failed',
        generateStatus: 'Generate status',
        fileName: 'File name',
        fileInfo: 'File information',
        fileDownload: 'File download',
        reGenerate: 'Re-generate',
        downloadCount: 'Download count',
        downloadRecord: 'Download record',
        downloadTime: 'Download time',
        operatorTime: 'Operation time',
        roleNumber: 'Role number',
        roleName: 'Role name',
        sort: 'Sort',
        operation: 'Operation',
        permission: 'Permission',
        createSubAccount: 'Create sub account',
        username: 'Username',
        account: 'Account',
        pleaseSelectRole: 'Please select a role',
        accountStatus: 'Account status',
        normal: 'Normal',
        disabled: 'Disabled',
        role: 'Account role',
        createTime: 'Create time',
        resetPassword: 'Reset password',
        sharedAccountData: 'Shared account data',
        companyName: 'Company name',
        distributionAccount: 'Distribution account',
        identifier: 'Identifier',
        level: 'Level',
        logisticsChannel: 'Logistics channel',
        accountBalance: 'Account balance',
        distributionDataStatistics: 'Distribution data statistics',
        totalOrders: 'Total orders',
        totalItems: 'Total items',
        totalCancelItems: 'Total canceled items',
        currentMonthCancelItems: 'Current month canceled items',
        totalRecharge: 'Total recharge',
        totalExpenditure: 'Total expenditure',
        currentMonthOrders: 'Current month orders',
        currentMonthItems: 'Current month items',
        totalPayOrders: 'Total pay orders',
        totalPayItems: 'Total pay items',
        currentMonthPayOrders: 'Current month pay orders',
        currentMonthPayItems: 'Current month pay items',
        viewLastMonthData: 'View last month data',
        lastMonthOrders: 'Last month orders',
        lastMonthItems: 'Last month items',
        lastMonthCancelItems: 'Last month canceled items',
        lastMonthPayOrders: 'Last month pay orders',
        lastMonthPayItems: 'Last month pay items',
        lastMonthTotalRecharge: 'Last month total recharge',
        lastMonthTotalExpenditure: 'Last month total expenditure',
        distributionAccounts: 'Distribution accounts',
        accountNickname: 'Account nickname',
        mainAccount: 'Main account',
        remark: 'Remark',
        createdTime: 'Create time',
        pickUpInfo: 'Pick up information',
        viewOrder: 'View order',
        logOff: 'Log off',
        pleaseUseEnglishOrPinyin: 'Please use English or Pinyin to fill in the sender information',
        senderName: 'Sender name',
        senderState: 'Sender state',
        senderCity: 'Sender city',
        company: 'Company name',
        email: 'Email',
        withdrawType: 'Withdraw type',
        orderCommissionAmount: 'Order commission amount',
        shippingCommissionAmount: 'Shipping commission amount',
        shippingReturnFee: 'Shipping return fee',
        withdrawAmount: 'Withdraw amount',
        yuan:'yuan',
        orderCommissionWithdrawableAmount: 'Order commission withdrawable amount',
        shippingCommissionWithdrawableAmount: 'Shipping commission withdrawable amount',
        shippingReturnFeeWithdrawableAmount: 'Shipping return fee withdrawable amount',
        alipay: 'Alipay',
        bankCard: 'Bank card',
        wechat: 'Wechat',
        accountInfo: 'Account information',
        oldPassword: 'Old password',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
        submit: 'Submit',
        recipient: 'Recipient',
        region: 'Region',
        setDefault: 'Set default',
        cancelDefault: 'Cancel default',
        deleteAddressConfirm: 'Delete address, continue?',
        pleaseSelectPermission: 'Please select permission！！！',
        deleteLabel: 'Delete label, continue?',
        password: 'Password',
        userName: 'User name',

        orderInfo: 'Order information',
        distributionCompanyName: 'Distribution company name',
        accountName: 'Account name',
        accountPassword: 'Account password',
        phoneNumber: 'Phone number',
        deliverWay: 'Deliver way',
        customerDescription: 'Customer description',
        phoneNumberCannotBeEmpty: 'Phone number cannot be empty',
        pleaseCorrectPhoneNumber: 'Please enter a correct phone number',
        pleaseEnterCategoryName: 'Please enter category name',
        accountNameOrPinyin: 'Account name cannot contain Chinese characters or Chinese characters',
        pleaseEnterAccountName: 'Please enter account name',
        pleaseEnterUserName: 'Please enter user name',
        pleaseEnterPassword: 'Please enter password',
        pleaseSelectDeliverWay: 'Please select deliver way',
        pleaseSelectOpenPick: 'Please select open pick',
        productName: 'Product name',
        productSku: 'Product SKU',
        templateCategory: 'Template category',
        productInfo: 'Product information',
        adjustDistributionPrice: 'Adjust distribution price',
        craft: 'Craft',
        pickUpPrice: 'Pick up price',
        distributionPrice: 'Distribution price（￥）',
        lowerLevelDistributionPrice: 'Lower level distribution price（￥）',
        profit: 'Profit（￥）',
        shopName: 'Shop name',
        platformShopOperator: 'Platform/shop/operator',
        time: 'Time',
        platformOrderTime: 'Platform order time',
        systemSyncTime: 'System sync time',
        latestDeliveryTime: 'Latest delivery time',
        processSize: 'Process size',
        orderProductInfo: 'Order product information',
        quantity: 'Quantity',
        price: 'Price（￥）',
        status: 'Status',
        pending: 'Pending',
        designing: 'Designing',
        designCompleted: 'Design completed',
        productionCompleted: 'Production completed',
        qualityInspection: 'Quality inspection',
        pendingDelivery: 'Pending delivery',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
        factory: 'Factory',
        orderNumber: 'Order number',
        delivery: 'Delivery',
        distributionInfo: 'Distribution information',
        totalStoreNums: 'Total store nums',
        totalPicSize: 'Total pic size',
        totalChildrenAccount: 'Total children account',
        userQuota: 'User quota',
    },

    v_header: {
        goHome: 'Go home',
        shoppingCart: 'Shopping cart',
        processingCenter: 'Processing center',
        productPendingGeneration: 'Product pending generation',
        handle: 'Handle',
        notification: 'Notification',
        youAreWelcome: 'You are welcome!',
        balance: 'Balance',
        unit: 'Yuan',
        rebate: 'Rebate',
        freezeAmount: 'Freeze { frozen_money } (meta) to view',
        accountInfo: 'Account information',
        transactionRecords: 'Transaction records',
        logOff: 'Log off',
    },

    shoppingCart: {
        shoppingCart: 'Shopping cart',
        product: 'Product',
        name: 'Name',
        shippingCenter: 'Shipping center',
        pickUpSku: 'Pick up SKU',
        productIdentifier: 'Product identifier',
        compositeProductId: 'Composite product ID',
        processSize: 'Process size',
        craft: 'Craft',
        size: 'Size',
        price: 'Price(￥)',
        quantity: 'Quantity',
        addTime: 'Add time',
        operation: 'Operation',
        delete: 'Delete selected products',
        totalPrice: 'Total price',
        checkout: 'Checkout',
        pleaseSelectItems: 'Please select the items you need to operate',
        confirmDelete: 'Are you sure you want to delete the selected products?',
        checkoutPriceException: 'Settlement data price exception, please contact the administrator for processing',
        checkoutFactoryException: 'Products from different factories cannot be settled for production',
        pleaseSelectCheckoutItems: 'Please select the products you need to settle',
    },

    checkout_cart: {
        checkoutCart: 'Checkout cart',
        productInfo: 'Product information',
        name: 'Name',
        shippingCenter: 'Shipping center',
        pickUpSku: 'Pick up SKU',
        productIdentifier: 'Product identifier',
        compositeProductId: 'Composite product ID',
        processSize: 'Process size',
        price: 'Price(￥)',
        unitPrice: 'Unit price(￥)',
        quantity: 'Quantity',
        subTotal: 'Subtotal',
        operation: 'Operation',
        orderBelong: 'Order belong',
        platformOrderNumber: 'Platform order number',
        optional: 'Optional, the content entered will generate a platform order number',
        shop: 'Shop',
        shopTip: 'If you do not have a shop in the account, the checkout cart will automatically create a self-service shop',
        deliveryMethod: 'Delivery method',
        shipments:'Shipments',
        FBAShipping:'FBA shipping',
        pickUp:'Pick up',
        preOrder:'Pre-order',
        recipientInfo:'Recipient information',
        preOrderTip:'After the product pre-order is completed, it will be temporarily stored in the ZFT warehouse for later order generation and quick shipping',
        orderTotal:'Order total',
        submit:'Submit order',
        pleaseAddress:'Please select a delivery address',
        confirmSubmit:'Checkout cart submission successful, order generated?',
        goToOrderView:'Go to order view',
        returnToShoppingCart:'Return to shopping cart',
    },

    recharge: {
        recharge: 'Recharge',
        accountInformation: 'Account information',
        rechargeAccount: 'Recharge account',
        availableBalance: 'Available balance',
        onlinePayment: 'Online payment',
        bankTransfer: 'Bank transfer (offline remittance)',
        rechargeAmount: 'Recharge amount',
        unit: 'Yuan',
        customAmount: 'Custom amount',
        minimumRechargeAmount: 'Minimum recharge amount is not less than 10 yuan integer',
        paymentMethod: 'Payment method',
        paymentAmount: 'Payment amount',
        immediatePayment: 'Immediate payment',
        companyInfo: 'Company information',
        companyName: 'Company name',
        bankName: 'Bank name',
        bankAccount: 'Bank account',
        openingBank: 'Opening bank',
        prompt: 'Warm prompt: to ensure that your funds are received in a timely manner, please keep a screenshot of the transfer after the transfer and contact the sales staff for account entry operations; if you have any questions, please contact the online customer service or business manager.',
        pleaseInformation: 'Please configure payment information first',
    },
}